import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const newDashboardApi = createAsyncThunk(
  "newDashboard",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/newadmindashboardData", {
      params,
    });
    return response.data;
  }
);

const newDashboardSliceSlice = createSlice({
  name: "newDashboard",
  initialState: {
    newDashboard: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(newDashboardApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(newDashboardApi.fulfilled, (state, action) => {
        state.newDashboard = action.payload;
        state.loading = false;
      })
      .addCase(newDashboardApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default newDashboardSliceSlice.reducer;
